import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export const useBilling = () => {
  const [busy, setBusy] = useState(false);
  const go = (path) => async () => {
    setBusy(true);
    try {
      const { data } = await api.post(path);
      window.location.href = data.checkout_url || data.url;
    } catch (e) {
      toast.error(errorMessage(e, "Couldn't open billing. Please try again."));
      setBusy(false);
    }
  };
  return { busy, startCheckout: go("/billing/checkout"), openPortal: go("/billing/portal") };
};
